import { render, staticRenderFns } from "./view-shipment.vue?vue&type=template&id=d4900a08&scoped=true"
import script from "./view-shipment.vue?vue&type=script&lang=js"
export * from "./view-shipment.vue?vue&type=script&lang=js"
import style0 from "./view-shipment.vue?vue&type=style&index=0&id=d4900a08&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4900a08",
  null
  
)

export default component.exports